import useBreakpointIndex, { DefaultOptions } from "./useBreakpointIndex";

function useResponsiveValue<T>(
  values: T[] | T,
  options: DefaultOptions = {}
): T {
  const array = Array.isArray(values) ? values : [values];
  const index = useBreakpointIndex(options);

  return array[index >= array.length ? array.length - 1 : index];
}

export default useResponsiveValue;
